module.exports = {"610625001":"保安街道","610625101":"杏河镇","610625102":"顺宁镇","610625103":"旦八镇","610625104":"金丁镇","610625105":"永宁镇","610625106":"义正镇","610625107":"双河镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610625.json
// module id = 2630
// module chunks = 0